<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="projectID" class="d-flex justify-content-center">{{project.projectName}}</h1>
                        <h1 v-if="!projectID" class="d-flex justify-content-center">Create New Project</h1>
                    </div>
                </div>
            </div>
        </div>
        <b-spinner class="center-spinner" v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <div class="container" v-if="!loading">
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <div class="form-group" v-if="projectID"> <label>Project Number</label> <input type="text" class="form-control w-50" placeholder="Enter Project number" required="required" v-model="project.projectNumber" disabled> </div>

                        <div class="form-group" v-if="!projectID"> <label>Project Number</label> <input type="text" class="form-control w-50" placeholder="Enter Project number" required="required" v-model="project.projectNumber"> </div>
                        <div class="form-group">
                            <label for="Users">PI</label>
                            <ul>
                                <li v-if="selectedPIUsers && selectedPIUsers.length == 0">None</li>
                                <li v-for="user in selectedPIUsers">
                                    {{user.displayName}}
                                    <button type="button" class="close" style="float:none" @click="removePIUser(user.id)">
                                        <span>&times;</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="form-group">
                            <b-form-select class="w-50" v-model="selectedPIUser" :options="selectUsers" @change="selectPIUser($event)" value-field="id" text-field="displayName">
                                <template #first>
                                    <option :value="null" disabled>Choose a user</option>
                                </template>
                            </b-form-select>
                        </div>
                        <div class="form-group"> <label>Project Name</label> <input type="text" class="form-control w-50" placeholder="Enter Project Name" required="required" v-model="project.projectName"> </div>


                        <div class="form-group"> <label>Start Date</label> <input type="date" class="form-control w-25" required="required" v-model="project.startDate" name="startdate"> </div>

                        <div class="form-group"> <label>End Date</label> <input type="date" class="form-control w-25" required="required" v-model="project.endDate" name="enddate"> </div>


                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="project.archived">
                            <label class="form-check-label" for="archived">
                                Archive
                            </label>
                        </div>

                        <button v-if="projectID" @click="handleSubmit" class="btn btn-primary btn-lg">Save</button>
                        <button v-if="!projectID" @click="handleCreateSubmit" class="btn btn-primary btn-lg">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    // @ is an alias to /src
    import axios from 'axios'
    import ProjectService from '../services/ProjectService';
    import UserService from '../services/UserService';

    export default {
        name: 'projects-edit',
        components: {
        },
        data: function () {
            return {
                project: {},
                loading: true,
                errored: false,
                projectID: null,
                users: [],
                selectedPIUsers: [],
                selectUsers: [],
                selectedPIUser: null,
                projectManagersSelected: [],
                hash: null
            }
        },
        created() {
            this.projectID = this.$route.params.id;
            this.setPromptSave();
            this.hash = this.hashData;
        },
        computed: {
            hashData: function () {
                ////clear out old managers
                this.project.projectManagers = [];

                //map pis
                for (var i = this.selectedPIUsers.length - 1; i >= 0; i--) {
                    this.project.projectManagers.push({ userId: this.selectedPIUsers[i].id });
                }
                return JSON.stringify(this.project);
            }
        },
        async beforeMount() {

            //TODO: refactor into enterprise http client
            try {
                this.users = await UserService.getUsers();
                if (this.projectID) {
                    let project = await ProjectService.getProject(this.projectID);
                    //format date
                    project.startDate = new Date(project.startDate).toISOString().split('T')[0]
                    project.endDate = new Date(project.endDate).toISOString().split('T')[0]

                    //set default project managers
                    for (var i = project.projectManagers.length - 1; i >= 0; i--) {
                        let pm = project.projectManagers[i];
                        this.projectManagersSelected.push(pm.userId);
                        let user = this.users.find((u) => u.id == pm.userId);
                        if (user) {
                            pm.displayName = user.displayName;
                            this.selectedPIUsers.push(user);
                        }
                    }

                    this.project = project;
                }

                this.selectUsers = this.users.filter((p) => !this.selectedPIUsers.find((up) => up.id == p.id));
            }
            catch (error) {
                this.$notify({
                    group: 'errors',
                    type: 'error',
                    title: 'Error',
                    text: error
                });
                this.errored = true
                this.loading = false;
            }

            this.loading = false;
        },
        mounted() {

        },
        methods: {
            handleSubmit: function () {

                ////clear out old managers
                this.project.projectManagers = [];

                //map pis
                for (var i = this.selectedPIUsers.length - 1; i >= 0; i--) {
                    this.project.projectManagers.push({ userId: this.selectedPIUsers[i].id });
                }

                axios
                    .put(this.$hostname + 'projects/', this.project, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(() => {
                        this.$router.push('/projects');
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false
                    )
            },

            handleCreateSubmit: function () {

                ////clear out old managers
                this.project.projectManagers = [];

                //map pis
                for (var i = this.selectedPIUsers.length - 1; i >= 0; i--) {
                    this.project.projectManagers.push({ userId: this.selectedPIUsers[i].id });
                }

                axios
                    .post(this.$hostname + 'projects/', this.project, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(() => {
                        this.$router.push('/projects');
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false
                    )
            },
            selectPIUser(id) {
                this.selectedPIUsers.push(this.users.find((p) => p.id == id))
                this.selectUsers = this.users.filter((p) => !this.selectedPIUsers.find((up) => up.id == p.id));
                this.selectedPIUser = null;
            },
            removePIUser: function (id) {
                this.selectedPIUsers = this.selectedPIUsers.filter((p) => p.id != id);
                this.selectUsers = this.users.filter((p) => !this.selectedPIUsers.find((up) => up.id == p.id));
            },
            setPromptSave() {
                window.onbeforeunload = (event) => {
                    if (this.$data.hash !== this.hashData) {
                        return true
                    }
                    else {
                        console.log("Data has not changed");
                        event.preventDefault();
                    }                       
                };
            }
        }
    }
</script>